import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const StoreInfoChecks = ({
  isMarketplace,
  isVerified,
  isCnpjValid,
  hasPhysicalStore,
}) => {
  const theme = useTheme();
  const setStoreChecksIconColor = useCallback((isCheckActive) =>
    isCheckActive
      ? theme.app.storeInfo.checkedForeground
      : theme.app.storeInfo.uncheckedForeground
  );

  return (
    <Flex
      borderTop="1px solid"
      flexDirection="column"
      pt={4}
      borderColor={theme.app.storeInfo.border}
    >
      <Flex alignItems="center" justifyContent="space-between" mb={2} full>
        <Text size="size1">
          {isMarketplace ? 'Marketplace verificado' : 'Loja verificada'}
        </Text>
        <Icon
          name="check-circle"
          size="size2"
          color={setStoreChecksIconColor(isVerified)}
          ml={[1, null, 2]}
        />
      </Flex>
      <Flex alignItems="center" justifyContent="space-between" mb={2} full>
        <Text size="size1">CNPJ verificado</Text>
        <Icon
          name="check-circle"
          size="size2"
          color={setStoreChecksIconColor(isCnpjValid)}
          ml={[1, null, 2]}
        />
      </Flex>
      <Flex alignItems="center" justifyContent="space-between" full>
        <Text size="size1">Possui loja física</Text>
        <Icon
          name="check-circle"
          size="size2"
          color={setStoreChecksIconColor(hasPhysicalStore)}
          ml={[1, null, 2]}
        />
      </Flex>
    </Flex>
  );
};

StoreInfoChecks.propTypes = {
  isMarketplace: PropTypes.bool.isRequired,
  isVerified: PropTypes.bool.isRequired,
  isCnpjValid: PropTypes.bool.isRequired,
  hasPhysicalStore: PropTypes.bool.isRequired,
};

export default StoreInfoChecks;
